
/* injects from baggage-loader */

import get from 'lodash/get'
import parseDate from 'utils/parseDate'
import isNumber from 'lodash/isNumber'
import isString from 'lodash/isString'
import map from 'lodash/map'
import sortBy from 'lodash/sortBy'
import loadTypes from 'utils/loadTypes'
import partial from 'utils/partial'
import * as _ from 'lodash'

export const ORDERS = loadTypes('ORDERS')
export const EXPORT_ORDERS = loadTypes('EXPORT_ORDERS')
export const ORDERS_STATS = loadTypes('ORDERS_STATS')
export const ORDERS_BY_ID = loadTypes('ORDERS_BY_ID')
export const ORDERS_PER_PAGE = 30
export const ORDERS_SET_FILTER = 'ORDERS_SET_FILTER'
export const ORDERS_SET_SESSION_FILTER = 'ORDERS_SET_SESSION_FILTER'
export const ORDERS_RESET_FILTERS = 'ORDERS_RESET_FILTERS'
export const ORDERS_RESET_ALL = 'ORDERS_RESET_ALL'
export const ORDERS_SET_SESSIONS_ONLY = 'ORDERS_SET_SESSIONS_ONLY'

const initialState = {
  list: null,
  listFetching: false,
  listByIds: null,
  listByIdsFetching: false,
  listSkip: 0,
  listTotal: 0,
  filters: {
    countries: [],
    customerType: null,
    orderTime: null,
    productCount: null,
    visitsBeforeOrder: null
  },
  globalStats: null,
  globalStatsFetching: false,
  stats: null,
  sessions: {
    first: null,
    firstInterval: null,
    second: null,
    secondInterval: null,
    includes: null,
    penultimateInterval: null,
    penultimate: null,
    lastInterval: null,
    last: null,
    hasImpression: true
  },
  sessionsOnly: false
}

export default function orders(state = initialState, action) {
  switch (action.type) {
    case ORDERS.REQUEST:
      return {
        ...state,
        listFetching: true
      }
    case ORDERS.SUCCESS:
      return {
        ...state,
        listFetching: false,
        stats: ordersStatsProcessor(action, 'filtered'),
        ...ordersProcessor(action)
      }
    case ORDERS.FAILURE:
      return {
        ...state,
        listFetching: false
      }
    case ORDERS_STATS.REQUEST:
      return {
        ...state,
        globalStatsFetching: true
      }
    case ORDERS_STATS.SUCCESS:
      return {
        ...state,
        globalStatsFetching: false,
        globalStats: ordersStatsProcessor(action, 'all')
      }
    case ORDERS_STATS.FAILURE:
      return {
        ...state,
        globalStatsFetching: false
      }
    case ORDERS_BY_ID.REQUEST:
      return {
        ...state,
        listByIdsFetching: true
      }
    case ORDERS_BY_ID.SUCCESS:
      return {
        ...state,
        listByIdsFetching: false,
        listByIds: orderByIdProcessor(action.response)
      }
    case ORDERS_BY_ID.FAILURE:
      return {
        ...state,
        listByIdsFetching: false
      }
    case ORDERS_SET_FILTER:
      return {
        ...state,
        filters: {
          ...state.filters,
          [action.filterType]: action.filterValue
        }
      }

    case ORDERS_SET_SESSIONS_ONLY:
      return {
        ...state,
        sessionsOnly: action.value
      }

    case ORDERS_SET_SESSION_FILTER:
      return {
        ...state,
        sessions: {
          ...state.sessions,
          [action.filterType]: action.filterValue,
          [action.filterType + 'ChannelTypes']: action.channelTypes
        }
      }
    case ORDERS_RESET_FILTERS:
      return {
        ...state,
        filters: initialState.filters,
        sessions: initialState.sessions
      }
    case ORDERS_RESET_ALL:
      return {
        ...state,
        filters: initialState.filters,
        sessions: initialState.sessions,
        globalStats: null,
        stats: null
      }
    default:
      return state
  }
}

function ordersProcessor(action) {
  const {request, response, headers} = action
  const {orders} = response

  if (!orders) return null

  return {
    listFetching: false,
    listSkip: request.body.skip,
    listTotal: headers['result-count'],
    list: response.orders.reduce((acc, order) => {
      acc[order.orderId] = orderReducer(order)
      return acc
    }, {})
  }
}

function ordersStatsProcessor(action, name) {
  const {response, headers} = action
  return {
    ...response.aggregations,
    name,
    total: headers['result-count'],
    countries: response.countries
  }
}

function orderByIdProcessor(response) {
  const {orders} = response

  if (!orders) return null

  return orders.reduce((acc, order) => {
    acc[order.orderId] = orderReducer(order)
    return acc
  }, {})
}

export function orderReducer(order) {
  const {sessions, orderItems, conversions} = order
  const {value: amount, currency} = order.convertedTotal || order.total || {}
  const info = get(order, 'customer.display', {})
  const parsedAmount = isString(amount)
    ? parseFloat(amount.replace(',', '.'))
    : amount
  console.log('orderReducer')

  const conversionTouchs = (conversions || []).map(conversionReducer)
  const touchpoints = (sessions || []).map(sessionReducer)

  _.map(conversionTouchs, conversionTouch => {
    let index = _.findIndex(touchpoints, touchpoint => {
      return conversionTouch.startedAt < touchpoint.startedAt
    })

    index = index !== -1 ? index : touchpoints.length

    if (index !== -1) {
      touchpoints.splice(index, 0, conversionTouch)
    }
  })
  // const touchpoints = [...sessionTouchs, ...conversionTouchs].sort((t1, t2) => {
  //   return t1.startedAt - t2.startedAt
  // })

  return {
    id: order.orderId,
    customer: {
      id: order.customerId,
      createdAt: get(order, 'customer.createdAt', null),
      isNew: order.repeat === 'new',
      info: Object.keys(info).length !== 0 ? info : null
    },
    amount:
      !isNaN(parsedAmount) && isNumber(parsedAmount) ? parsedAmount : null,
    currency,
    new: order.repeat === 'new',
    orderItems: (orderItems || []).map(
      partial(orderItemsReducer, order.totalOriginalCurrency.currency)
    ),
    touchpoints: touchpoints,
    date: order.createdAt ? parseDate(order.createdAt) : null
  }
}

function orderItemsReducer(currency, item) {
  const {quantity = 1, name, price} = item

  return {quantity, name, price, currency}
}

function sessionReducer(session, index, sessions) {
  const startedAt = get(session, 'createdAt', null)
  const endedAt = get(session, 'lastRequestAt', null)
  const impressions = get(session, 'impressions', null)

  const parsedImpressions = map(impressions, value => {
    const info = JSON.parse(value)
    return {
      viewCount: info.impressionCount,
      lastView: info.createdAt,
      group: info.channelGroup,
      channel: info.channel,
      channelType: info.channelType || '',
      campaign: info.campaign
    }
  }).filter(impression => {
    return impression.viewCount
  })

  return {
    type: 'session',
    channel: get(session, 'channel.dv_channel', null),
    channelGroup: get(session, 'channel.dv_chgroup', null),
    channelType: get(session, 'channel.dv_chtype', ''),
    campaign: get(session, 'campaign', ''),
    virtual: get(session, 'channel.virtual', null),
    device: get(session, 'device', null),
    impressions: parsedImpressions,
    landingPage: get(session, 'landingPage', null),
    startedAt: startedAt ? parseDate(startedAt) : null,
    endedAt: endedAt ? parseDate(endedAt) : null,
    pageviewCount: get(session, 'pageviewCount', null)
  }
}

function conversionReducer(conversion) {
  const startedAt = get(conversion, 'time', null)
  const conversionType = get(conversion, 'type', null)

  return {
    type: 'conversion',
    startedAt: startedAt ? parseDate(startedAt) : null,
    conversionType
  }
}



// WEBPACK FOOTER //
// ./client/redux/modules/orders/index.js